import { render, staticRenderFns } from "./ViewRPurchase.vue?vue&type=template&id=4c6ce83e"
import script from "./ViewRPurchase.vue?vue&type=script&lang=js"
export * from "./ViewRPurchase.vue?vue&type=script&lang=js"
import style0 from "./ViewRPurchase.vue?vue&type=style&index=0&id=4c6ce83e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports